import React, { useState, useEffect } from "react";
import Slider from "react-slick";

function SliderArrowNext(props) {
  const { className, onClick, style } = props;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        ...style,
        background: "url('../assets/images/arrowright.svg') no-repeat",
        content: " ",
        backgroundSize: "100%",
        width: "40px",
        height: "40px",
        zIndex: "99",
        right: "-10px",
      }}
    ></div>
  );
}

function SliderArrowPrev(props) {
  const { className, onClick, style } = props;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        ...style,
        background: "url('../assets/images/arrowleft.svg') no-repeat",
        content: " ",
        backgroundSize: "100%",
        width: "40px",
        height: "40px",
        zIndex: "99",
      }}
    ></div>
  );
}

const PeopleImage = () => {
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4.2,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    nextArrow: <SliderArrowNext />,
    prevArrow: <SliderArrowPrev />,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
          arrows: false,
        },
      },
    ],
  };
  return (
    <>
      <section>
        <div className="container">
          <div className="slider_wall">
            <Slider {...settings}>
              <div>
                <img
                  src="/assets/images/img-31.jpg"
                  className="slider_img"
                  alt=""
                />
              </div>
              <div>
                <img
                  src="/assets/images/img-32.jpg"
                  className="slider_img"
                  alt=""
                />
              </div>
              <div>
                <img
                  src="/assets/images/img-33.jpg"
                  className="slider_img"
                  alt=""
                />
              </div>
              <div>
                <img
                  src="/assets/images/img-34.jpg"
                  className="slider_img"
                  alt=""
                />
              </div>
              <div>
                <img
                  src="/assets/images/img-35.jpg"
                  className="slider_img"
                  alt=""
                />
              </div>

              <div>
                <img
                  src="/assets/images/img-36.jpg"
                  className="slider_img"
                  alt=""
                />
              </div>

              <div>
                <img
                  src="/assets/images/img-37.jpg"
                  className="slider_img"
                  alt=""
                />
              </div>

              <div>
                <img
                  src="/assets/images/img-38.jpg"
                  className="slider_img"
                  alt=""
                />
              </div>
            </Slider>
          </div>
        </div>
      </section>
    </>
  );
};

export default PeopleImage;
